import Util from '@/lib/util'
export default [
    {
        title:Util.L('Code'),
        key:'code'
    },{
        title:Util.L('Name'),
        key:'name'
    },{
        title:Util.L('CreationTime'),
        key:'creationTime',
        render:(h:any,params:any)=>{
             return h("span", Util.toViewDateString(params.row.creationTime));
        }
    }]
